import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { ArrowRightIcon } from 'lucide-react';
export function STCombine() {
  return <section className="bg-[#FF1493] py-[60px] lg:py-[100px]" data-id="element-1979">
      <div className="max-w-[1000px] mx-auto px-6 lg:px-8" data-id="element-1980">
        <AnimateOnScroll className="text-center flex flex-col items-center" data-id="element-1981">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-8 font-[600] font-[Poppins,_sans-serif]" data-id="element-1982">
            COMBINE SKINTYTE WITH THESE TREATMENTS
          </h2>

          <div className="space-y-6 text-white text-[17px] leading-[1.7] font-body mb-10 max-w-[800px]" data-id="element-1983">
            <p data-id="element-1984">
              SkinTyte works wonders on its own, but if you are looking to
              maximize your results, combine your treatment with ClearSilk or
              BBL!
            </p>
            <p className="italic" data-id="element-1985">
              "I really love adding this procedure to a regular BBL," says Dr.
              Fiona. "It's just the added tightening and lifting effect that
              only the SkinTyte + BBL combo can get for you, almost
              instantaneously turning back the clock for a more youthful look."
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-6 mb-10 w-full sm:w-auto" data-id="element-1986">
            <a href="#" className="bg-white px-10 py-6 shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex items-center justify-between gap-6 min-w-[200px]" data-id="element-1987">
              <span className="text-black text-xl font-bold font-[Poppins,_sans-serif]" data-id="element-1988">
                ClearSilk
              </span>
              <ArrowRightIcon size={20} className="text-[#FF1493]" data-id="element-1989" />
            </a>
            <a href="#" className="bg-white px-10 py-6 shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex items-center justify-between gap-6 min-w-[200px]" data-id="element-1990">
              <span className="text-black text-xl font-bold font-[Poppins,_sans-serif]" data-id="element-1991">
                BBL
              </span>
              <ArrowRightIcon size={20} className="text-[#FF1493]" data-id="element-1992" />
            </a>
          </div>

          <p className="font-serif italic text-white text-2xl lg:text-[28px]" data-id="element-1993">
            Treat yourself!
          </p>
        </AnimateOnScroll>
      </div>
    </section>;
}